export default __webpack_public_path__ + "static/media/loxonet.hathi.logo.403f8891.png";